import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";

const MODES = [
  { value: "instant", label: "⚡ Instant", credits: 2 },
  { value: "smart-saver", label: "⏳ Smart Saver", credits: 1 }
];

const labelFor = (p) =>
  p?.name || p?.company_name || p?.product_name || "Unnamed profile";

const SellerProfileBar = observer(({
  profiles = [],
  activeProfileId,
  loadedResearchProfileId,
  mode,
  onModeChange,
  onSelectProfile,
  onAddNewProfile,
  onEditProfile
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const hasProfiles = profiles.length > 0;
  const activeProfile = profiles.find(p => p.id === activeProfileId) || null;
  const triggerLabel = activeProfile ? labelFor(activeProfile) : "No seller profile";

  const handlePick = (id) => {
    onSelectProfile && onSelectProfile(id);
    setOpen(false);
  };

  const handleAddNew = () => {
    setOpen(false);
    onAddNewProfile && onAddNewProfile();
  };

  return (
    <div className="drSellerBar">
      <div className="drSellerInfo">
        <span className="drSellerLabel">Seller:</span>

        {hasProfiles ? (
          <div className="drSellerDropdown" ref={ref}>
            <button
              type="button"
              className={`drSellerDropdownTrigger ${open ? "active" : ""}`}
              onClick={() => setOpen(o => !o)}
            >
              <span className="drSellerDropdownText">{triggerLabel}</span>
              <i className={`material-icons drSellerDropdownArrow ${open ? "open" : ""}`}>
                expand_more
              </i>
            </button>

            {open && (
              <div className="drSellerDropdownMenu">
                {profiles.map(p => {
                  const checked = p.id === activeProfileId;
                  return (
                    <label
                      key={p.id}
                      className={`drSellerDropdownItem ${checked ? "checked" : ""}`}
                    >
                      <input
                        type="radio"
                        name="drSellerProfile"
                        checked={checked}
                        onChange={() => handlePick(p.id)}
                      />
                      <span className="drSellerRadio" />
                      <span className="drSellerItemLabel">{labelFor(p)}</span>
                    </label>
                  );
                })}
                <button
                  type="button"
                  className="drSellerDropdownAddNew"
                  onClick={handleAddNew}
                >
                  <i className="material-icons">add</i>
                  <span>Add new seller</span>
                </button>
                <a
                  className="drSellerDropdownManage"
                  href="/settings/seller-profiles"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpen(false)}
                >
                  <i className="material-icons">open_in_new</i>
                  <span>Manage all profiles</span>
                </a>
              </div>
            )}
          </div>
        ) : (
          <button className="drSellerSetupBtn" onClick={onAddNewProfile}>
            Set Up Profile
          </button>
        )}

        {activeProfile && (
          <button className="drSellerEditBtn" onClick={onEditProfile}>Edit</button>
        )}
        {loadedResearchProfileId &&
         activeProfileId &&
         loadedResearchProfileId !== activeProfileId && (
          <span className="drSellerSwitchHint">— different from the one used for current research</span>
        )}
      </div>

      <div className="drModeSelect">
        <select value={mode} onChange={e => onModeChange(e.target.value)}>
          {MODES.map(m => (
            <option key={m.value} value={m.value}>{m.label} ({m.credits} credits)</option>
          ))}
        </select>
      </div>
    </div>
  );
});

export default SellerProfileBar;
